/**
 * Table of Contents Component
 * Display heading navigation untuk blog posts
 */

import React from 'react';
import { ChevronDown } from 'lucide-react';

interface HeadingInfo {
  level: number;
  text: string;
  id: string;
}

interface TableOfContentsProps {
  headings: HeadingInfo[];
}

const TableOfContents: React.FC<TableOfContentsProps> = ({ headings }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  
  if (headings.length === 0) return null;

  const handleClick = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <div className="my-8 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      {/* Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between text-left font-semibold text-gray-900 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
      >
        <span>Table of Contents</span>
        <ChevronDown 
          size={20} 
          className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Contents */}
      {isOpen && (
        <nav className="mt-4 space-y-2">
          {headings.map((heading) => (
            <button
              key={heading.id}
              onClick={() => handleClick(heading.id)}
              className={`block w-full text-left transition-colors hover:text-blue-600 dark:hover:text-blue-400 text-sm
                ${heading.level === 2 
                  ? 'text-gray-900 dark:text-gray-100 font-medium' 
                  : 'text-gray-700 dark:text-gray-300 pl-4'
                }
              `}
            >
              {heading.text}
            </button>
          ))}
        </nav>
      )}
    </div>
  );
};

export default TableOfContents;
